import { NavCategory } from '@src/components/widgets/navigation/types'

export const hasMenuContent = (category: NavCategory | null): boolean => {
  if (!category) {
    return false
  }
  return [category.columns, category.featured, category.spotlight].some(arr => (arr?.length ?? 0) > 0)
}
